export { default } from './toPairsIn.js'



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/entriesIn.js
// module id = 384
// module chunks = 0